import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { AddExistingInvoiceModalComponent } from '../add-existing-invoice-modal/add-existing-invoice-modal.component';
import { GenerateInvoiceModalComponent } from '../generate-invoice-modal/generate-invoice-modal.component';

@Component({
  selector: 'app-new-order-modal',
  templateUrl: './new-order-modal.component.html',
  styleUrls: ['./new-order-modal.component.scss'],
})
export class NewOrderModalComponent implements OnInit {
  generateInvoice: boolean;
  addExistingInvoice: boolean;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private modalService: BoobleModalService
  ) { }

  ngOnInit() { }

  selectGenerateInvoice() {
    this.generateInvoice = true;
    this.addExistingInvoice = false;
  }

  selectAddExistingInvoice() {
    this.generateInvoice = false;
    this.addExistingInvoice = true;
  }

  goToInvoiceModal() {
    if (this.generateInvoice) {
      this.openGenerateInvoiceModal();
    } else if (this.addExistingInvoice) {
      this.openAddExistingInvoiceModal();
    }
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openGenerateInvoiceModal() {
    this.modalService.present(GenerateInvoiceModalComponent);
  }

  openAddExistingInvoiceModal() {
    this.modalService.present(AddExistingInvoiceModalComponent);
  }
}
